import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faGithub, faLinkedinIn, faMediumM, faTwitter } from "@fortawesome/free-brands-svg-icons";

export default function SocialHandle() {
  return (
    <div className="col-md-2 d-block socialMediaLink">
      <a href="https://www.linkedin.com/in/iamshakibb/" target="_blank" rel="noreferrer">
        <FontAwesomeIcon icon={faLinkedinIn} />
      </a>
      <a href="https://github.com/iamshakibb" target="_blank" rel="noreferrer">
        <FontAwesomeIcon icon={faGithub} />
      </a>
      <a href="https://twitter.com/iamshakibb" target="_blank" rel="noreferrer">
        <FontAwesomeIcon icon={faTwitter} />
      </a>
      <a href="https://medium.com/@iamshakibb" target="_blank" rel="noreferrer">
        <FontAwesomeIcon icon={faMediumM} />
      </a>
      <a href="https://www.facebook.com/iamshakibb" target="_blank" rel="noreferrer">
        <FontAwesomeIcon icon={faFacebookF} />
      </a>
    </div>
  );
}
